import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop"]

  toggle() {
    const open = this.menuTarget.classList.toggle("is-open")
    this.backdropTarget.classList.toggle("is-visible", open)
    document.body.classList.toggle("nav-open", open)
  }

  close() {
    this.menuTarget.classList.remove("is-open")
    this.backdropTarget.classList.remove("is-visible")
    document.body.classList.remove("nav-open")
  }
}
